import { z } from 'zod'

export const DocTemplateListSchema = z.object({
  active: z.boolean().optional(),
  documentName: z.string().optional(),
  frequency: z.string().optional(),
  level: z.string().optional(),
  page: z.number().int().nonnegative().optional(),
  size: z.number().int().nonnegative().optional(),
  sortDesc: z.boolean().optional(),
  startDateType: z.string().optional(),
  state: z.string().optional(),
  type: z.string().optional()
})
